<template>
    <section class="px-2 flex items-center flex-col">
        <div class="flex mb-4 justify-between w-full items-center mobile:flex-col">
            <Link
                class="text-main-accent cursor-pointer mobileXL:self-start"
                href="/"
            >
                <span v-html="collection.product_logo.path"/>
            </Link>

            <a
                class="lg:text-[10px] xl:text-[12px] text-[#383247] laptopXL_1:hidden"
                href="mailto:info@productland.ru"
            >productlandrus@gmail.com</a>

            <div class="flex gap-3 mobile:justify-between mobile::self-center mobile:mt-4">
                <!-- <span class="cursor-pointer" @click="proceedLinkSocials('fb')" v-html="collection.fbDark.path" />
                <span class="cursor-pointer" @click="proceedLinkSocials('insta')" v-html="collection.instaDark.path" /> -->
                <span
                    class="cursor-pointer text-main-primary p-[6.75px] flex items-center justify-center bg-[#E1E1E1] rounded-full"
                    @click="proceedLinkSocials('vk')"
                    v-html="collection.vk_footer.path"
                />
                <span
                    class="cursor-pointer text-main-primary p-[6.75px] flex items-center justify-center bg-[#E1E1E1] rounded-full"
                    @click="proceedLinkSocials('tg')"
                    v-html="collection.tg_footer.path"
                />
            </div>
        </div>

        <a
            v-if="!laptopXL_1"
            class="lg:text-[10px] xl:text-[12px] text-[#383247] mobileXL:text-[13px] mobileXL:text-center"
            href="mailto:info@productland.ru"
        >productlandrus@gmail.com</a>


        <div class="laptopXL_1:mt-4 mobileXL:text-center">
            <p class="mb-1 text-main-primary font-medium text-[0.8125rem]">© ProductLand, {{ year }}. Все права
                защищены.</p>
            <a class="mb-1 text-[#7E4798] font-normal text-[0.8125rem]"
               href="/privacy-policy">
                Политика обработки персональных данных</a>

        </div>


    </section>
</template>
<script setup>
import {icons as collection} from '@/shared/assets.js';
import {Link} from '@inertiajs/vue3';
import {computed} from 'vue';
import dayjs from 'dayjs';
import {useWindowDimensions} from '@/Pages/Main/helpers/dimentions.ts';

const routes = {
    tg: 'https://t.me/productland_russia',
    vk: 'https://vk.com/productcamp'
};

let year = computed(() => {
    return dayjs().format('YYYY');
});

const { laptopXL_1 } = useWindowDimensions();

const proceedLinkSocials = (key) => {
    window.open(routes[key], '_blank').focus();
    console.log(routes[key]);
};

</script>

<style scoped>

</style>
